/**
 * Машинные коды ошибок из `ApiError.code`, отдаваемые бэкендом
 * (см. `uz.beantech.p2ploans.common.ErrorCodes`).
 *
 * Используются в `notification-provider` для маппинга в i18n-ключи.
 * Ключи в `i18n/ru/errors.json` совпадают с этими константами.
 */
export const ErrorCodes = {
  UNKNOWN: 'UNKNOWN_ERROR',
  NETWORK: 'NETWORK_ERROR',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  INVALID_PHONE: 'INVALID_PHONE',
  OTP_INVALID: 'OTP_INVALID',
  OTP_EXPIRED: 'OTP_EXPIRED',
  OTP_TOO_MANY_ATTEMPTS: 'OTP_TOO_MANY_ATTEMPTS',
  UNAUTHORIZED: 'UNAUTHORIZED',
  INVALID_REFRESH: 'INVALID_REFRESH',
  FORBIDDEN: 'FORBIDDEN',
  NO_ADMIN_ACCESS: 'NO_ADMIN_ACCESS',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  DEVICE_NOT_FOUND: 'DEVICE_NOT_FOUND',
  SETTING_NOT_FOUND: 'SETTING_NOT_FOUND',
  INVALID_SETTING_VALUE: 'INVALID_SETTING_VALUE',
  ROLE_NOT_FOUND: 'ROLE_NOT_FOUND',
  ROLE_NAME_TAKEN: 'ROLE_NAME_TAKEN',
  ROLE_IN_USE: 'ROLE_IN_USE',
  PERMISSION_NOT_FOUND: 'PERMISSION_NOT_FOUND',
  RATE_LIMITED: 'RATE_LIMITED',
  INTERNAL: 'INTERNAL_ERROR',
} as const;

/**
 *
 */
export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
